// eslint-disable-next-line no-restricted-imports
import { trainCourseEntityName } from '../../../../../backend/config/classifiers/entities/defineTrainCourseClassifier';
import { isTrainFeatureEnabled } from '../../../../../ui/utils';
import { buildPublicDataValueProvider, buildStorageValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { buildProfessionalStatusValueProvider } from './utils';
import { buildOccupationValueProvider } from './utils/buildOccupationValueProvider';
export function buildCredentialingValueProviders(appName, userState) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const providers = [];
    if (!userState || ((_a = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _a === void 0 ? void 0 : _a.featureFlags.includes('medicalSpecialties'))) {
        const medicalSpecialties = [
            buildPublicDataValueProvider({ appName: appName, classifierName: 'abmsCertification', label: 'ABMS Certification' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'abnsCertification', label: 'ABNS Certification' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'abppCertification', label: 'ABPP Certification' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'aoaCertification', label: 'AOA Certification' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'aprnSpecialty', label: 'APRN Specialty' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'ascpSpecialty', label: 'ASCP Specialty' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'boardOfPharmaceuticalSpecialty',
                label: 'Board Of Pharmaceutical Specialty',
            }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'cardiovascularSpecialty',
                label: 'Cardiovascular Specialty',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'dentalSpecialty', label: 'Dental Specialty' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'laboratoryTechnicianSpecialty',
                label: 'Laboratory Technician Specialty',
            }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'laboratoryTechnologistSpecial',
                label: 'Laboratory Technologist Special',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'veterinarianSpecialty', label: 'Veterinarian Specialty' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'radiologicSpecialty', label: 'Radiologic Specialty' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'medicalRecordsItSpecialty',
                label: 'Medical Records & IT Specialty',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'mhcSpecialty', label: 'MHC Specialty' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'pharmacySpecialty', label: 'Pharmacy Specialty' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'physicianAssistantExperience',
                label: 'Physician Assistant Experience',
            }),
        ];
        providers.push(...medicalSpecialties);
    }
    if (!userState || ((_b = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _b === void 0 ? void 0 : _b.featureFlags.includes('deploymentAndPriorCommitments'))) {
        const deploymentAndPriorCommitments = [
            buildPublicDataValueProvider({ appName: appName, classifierName: 'deploymentDuration', label: 'Deployment Duration' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'deploymentTravelWillingness',
                label: 'Deployment Travel Willingness',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'deploymentType', label: 'Deployment Type' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'emergencyContactRelationship',
                label: 'Emergency Contact Relationship',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'priorCommitment', label: 'Prior Commitment' }),
        ];
        providers.push(...deploymentAndPriorCommitments);
    }
    if (!userState || ((_c = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _c === void 0 ? void 0 : _c.featureFlags.includes('occupations'))) {
        const occupations = [
            buildPublicDataValueProvider({ appName: appName, classifierName: 'hospital', label: 'Hospital' }),
            buildOccupationValueProvider(appName),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'occupationCredentialNames',
                label: 'Occupation Credential Names',
            }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'occupationFunction',
                label: 'Occupation Emergency Support Function',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'occupationGroup', label: 'Occupation Group' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'occupationReport', label: 'Occupation MRC Report' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'jasBoard', label: 'Jas Board' }),
            buildProfessionalStatusValueProvider(appName),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'veterinarianTechSpecialty',
                label: 'Veterinarian Technician Specialty',
            }),
        ];
        if (((_d = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _d === void 0 ? void 0 : _d.featureFlags.includes('credential')) || true) {
            providers.push(buildPublicDataValueProvider({ appName, classifierName: 'occupationCredential', label: 'Occupation Credential' }));
        }
        providers.push(...occupations);
    }
    if (!userState || ((_e = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _e === void 0 ? void 0 : _e.featureFlags.includes('skillsAndTrainings'))) {
        const skillsAndTrainings = [
            buildPublicDataValueProvider({ appName: appName, classifierName: 'language', label: 'Language' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'languageFluency', label: 'Language Fluency' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'skill', label: 'Skill' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'training', label: 'Training' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'writtenAbility', label: 'Written Ability' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'healthcareSkill', label: 'Healthcare Skill' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'otherSkill', label: 'Other Skill' }),
        ];
        providers.push(...skillsAndTrainings);
    }
    if (!userState || ((_f = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _f === void 0 ? void 0 : _f.featureFlags.includes('tribe'))) {
        providers.push(buildPublicDataValueProvider({ appName: appName, classifierName: 'tribe', label: 'Tribe' }));
    }
    if (!userState || ((_g = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _g === void 0 ? void 0 : _g.featureFlags.includes('personalInformation'))) {
        providers.push(...[
            buildPublicDataValueProvider({ appName: appName, classifierName: 'eyeColor', label: 'Eye Color' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'hairColor', label: 'Hair Color' }),
            buildPublicDataValueProvider({
                appName: appName,
                classifierName: 'driverLicenseEndorsement',
                label: 'Driver License Endorsement',
            }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'maritalStatus', label: 'Marital Status' }),
        ]);
    }
    if (!userState || ((_h = userState === null || userState === void 0 ? void 0 : userState.credentialing) === null || _h === void 0 ? void 0 : _h.featureFlags.includes('general'))) {
        providers.push(...[
            buildPublicDataValueProvider({ appName: appName, classifierName: 'incidentType', label: 'Incident Type' }),
            buildPublicDataValueProvider({ appName: appName, classifierName: 'referralOption', label: 'Referral Option' }),
        ]);
    }
    if (isTrainFeatureEnabled(userState)) {
        providers.push(buildStorageValueProvider({ entityName: trainCourseEntityName, label: 'Train Course', classifierName: 'trainCourse' }));
    }
    return providers;
}
